import { BASE_URL } from "../consts/BaseUrl";

export const  httpReqBlob = async (path, httpMethod, data, withToken) => {

    const verifyPath = path[0] !== '/' ? `/${path}` : path
    let headers = {
        'content-type': 'application/json'
        , accept: 'application/json'
    }
    let isTokenExpired = false
    if (withToken) {
        const t = JSON.parse(localStorage.getItem('asiaUserToken'))
        if (t) {
            const expiresIn = t.expiresIn;

            const dotNetTickToDate = (dotNetTick) => {
                const DOTNET_TO_UNIX_OFFSET = 621355968000000000;
                const unixMilliseconds = (dotNetTick - DOTNET_TO_UNIX_OFFSET) / 10000;
                return new Date(unixMilliseconds);
            }

            const expireDate = dotNetTickToDate(expiresIn)
            const now = new Date()
            const twoHoursAgo = new Date(now.getTime() - 2 * 60 * 60 * 1000);
            // console.log('new date -- ', new Date())
            // console.log('expireDate -- ', expireDate)

            if (expireDate <= new Date()) {
                isTokenExpired = true
            }
            headers = {...headers, Authorization: t.token}
        }
    }
    if (!isTokenExpired) {


        let fetchObj = {
            method: httpMethod.toUpperCase(),
            headers
        }
        if (data) {
            fetchObj = {...fetchObj, body: JSON.stringify(data)}
        }
        const url = `${BASE_URL}${verifyPath}`
        const response = await fetch(`${url}`, fetchObj)
        if (response.status === 204 || response.status === 401) return

        return response.blob()
    } else {
        localStorage.removeItem('asiaUserToken')
        localStorage.removeItem('asiaUser')
        window.location.href = "/";
        return null
    }
}